import { call, put } from "redux-saga/effects";
import { preferenceSetConcreteEtfs } from "../actions";

import { calculateFilterSettings } from "./calculateFilterSettings";
import { filterTable } from "./filterTable";

export function* clearFilter() {
	yield put(preferenceSetConcreteEtfs(null));
	yield call(calculateFilterSettings, true)
	yield call(filterTable);
}
